import styled from "styled-components";

export const StyledColorDot = styled("span")`
    background: ${(props) => props.$color};
    border-radius: 50%;
    width: ${(props) => props.$size}px;
    height: ${(props) => props.$size}px;
`;
